import { render, staticRenderFns } from "./500.vue?vue&type=template&id=55c86129&scoped=true&"
import script from "./500.vue?vue&type=script&lang=js&"
export * from "./500.vue?vue&type=script&lang=js&"
import style0 from "./500.vue?vue&type=style&index=0&id=55c86129&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c86129",
  null
  
)

export default component.exports